export default __webpack_public_path__ + "static/media/CZ.4920f112.svg";